import moment from "moment";
class employedWithPhoto {
  constructor(
    empId,
    file,
    typeDoc,
    numDoc,
    lastName,
    name,
    highDate,
    downDate,
    preview,
    tags
  ) {
    this.empId = empId;
    this.file = file;
    this.typeDoc = typeDoc;
    this.numDoc = numDoc;
    this.lastName = lastName;
    this.name = name;
    this.highDate = moment(highDate).utc().format("YYYY-MM-DD");
    this.downDate =
      downDate === null || downDate === undefined
        ? downDate
        : moment(downDate).utc().format("YYYY-MM-DD");
    this.fullName = name + " " + lastName;
    this.formatHighDate = moment(highDate).utc().format("DD-MM-YYYY");
    this.formatDownDate =
      downDate === null || downDate === undefined
        ? downDate
        : moment(downDate).utc().format("DD-MM-YYYY");
    this.preview = preview;
    this.tags = tags;
  }
  static fromJson({
    empId,
    apellido,
    nombre,
    legajo,
    tdoc,
    ndoc,
    fecAlta,
    fecBaja,
    vistaPrevia,
    etiquetas,
  }) {
    return new employedWithPhoto(
      empId,
      apellido,
      nombre,
      legajo,
      tdoc,
      ndoc,
      fecAlta,
      fecBaja,
      vistaPrevia,
      etiquetas
    );
  }
}
export default employedWithPhoto;
